import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import Button from 'sushiweb/Button/Button';
import ZImage from 'sushiweb/ZImage/ZImage';
import RightTriangle from 'sushiweb/Icons/all/RightTriangle';
import { AWW_SNAP_IMG } from '../../../../constants/images';
import { genericErrorMsg } from '../constants';
import { DataFetchError, Title } from './styles';

const ErrorPage = ({ showAction, actionLabel, clickAction, errorMsg }) => {
  return (
    <DataFetchError className='center'>
      <ZImage
        src={AWW_SNAP_IMG}
        width='22rem'
        height='21rem'
        fit='contain'
        alt='aww snap'
      />
      <Title>{errorMsg !== '' ? errorMsg : genericErrorMsg}</Title>
      {showAction && (
        <Button
          btnColor='red'
          iconAlign='right'
          icon={<RightTriangle />}
          onClick={clickAction}
        >
          {actionLabel}
        </Button>
      )}
    </DataFetchError>
  );
};

ErrorPage.propTypes = {
  showAction: PropTypes.bool,
  actionLabel: PropTypes.string,
  clickAction: PropTypes.func,
  errorMsg: PropTypes.string,
};

ErrorPage.defaultProps = {
  showAction: false,
  actionLabel: '',
  clickAction: _noop,
  errorMsg: '',
};

export default ErrorPage;
